import { Lock, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Composant réutilisable : reçoit le CONTEXTE (feature) et lit l'état/upgrade depuis
// l'identité résolue (Phase 1). Ne hardcode AUCUNE règle de plan (FREE/PREMIUM/PRO).
export function UpgradeNotice({ feature, title }) {
  const { features } = useAuth();
  const navigate = useNavigate();
  const meta = features?.[feature] || {};
  const upgrade = meta.upgrade_required;
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="upgrade-notice">
      <div className="max-w-md w-full text-center bg-[#18181E] border border-amber-500/30 rounded-3xl p-8">
        <div className="w-14 h-14 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-4 glow-gold">
          <Lock className="w-7 h-7 text-black" />
        </div>
        <h2 className="font-display text-2xl font-extrabold">{title || "Fonctionnalité verrouillée"}</h2>
        <p className="text-sm text-zinc-400 mt-2">
          Cette fonctionnalité est disponible {upgrade ? <span className="text-amber-400 font-semibold">avec l'offre {upgrade}</span> : "avec une offre supérieure"}.
        </p>
        <button onClick={() => navigate("/subscription")} data-testid="upgrade-cta"
          className="mt-5 inline-flex items-center gap-2 px-5 h-11 rounded-xl gold-gradient text-black font-semibold hover:opacity-90">
          <Sparkles className="w-4 h-4" /> Débloquer
        </button>
      </div>
    </div>
  );
}

// Petit badge pour la navigation (entrée pertinente mais verrouillée).
export function LockedBadge({ upgrade }) {
  return (
    <span data-testid="nav-locked-badge"
      className="ml-auto inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/30">
      <Lock className="w-3 h-3" /> {upgrade || "Pro"}
    </span>
  );
}
